export default "__VITE_ASSET__BV$nVauH__"